<template>
  <footer class="footer footer-custom">
    <div class="copyright m-auto text-center text-lg-left text-muted">
      <span class="footer-text">© {{year}} <span><b>uniBot Team</b></span></span>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
  .footer-custom {
    padding: 0 !important;
    height: 50px !important;
    display: flex;
    align-items: center;
  }
  .footer-text {
    color: #172b4d;
  }
</style>



// WEBPACK FOOTER //
// src/layout/ContentFooter.vue